export const formatPostalCode = (postalCode: string) => {
  return postalCode.replaceAll(' ', '').toUpperCase();
};

